export enum SelectOperatorChoice {
  Equal = '0',
  StartsWith = '1',
  Contains = '2',
}

export const list = Object.freeze([
  {
    id: SelectOperatorChoice.Equal,
    value: 'Uguale',
  },
  {
    id: SelectOperatorChoice.StartsWith,
    value: 'Tra',
  },
]);

export const listEqualOperator = Object.freeze([
  {
    id: SelectOperatorChoice.Equal,
    value: 'Uguale',
  },
]);

export const listNameOperator = Object.freeze([
  {
    id: SelectOperatorChoice.Equal,
    value: 'Uguale',
  },
  {
    id: SelectOperatorChoice.StartsWith,
    value: 'Inizia per',
  },
  {
    id: SelectOperatorChoice.Contains,
    value: 'Contiene',
  },
]);
